<template>
  <div style="height:100%">
    <project-table tabletype="personalList" v-on:delFiles="delFiles"  v-if="HasUsedWorkspace && /^\/space\/files\/list$/.test($route.path)">
    </project-table>
    <router-view v-else></router-view>
    <LoadingGif :loadingShow=loading></LoadingGif>
  </div>
</template>
<style lang="less">
  /* 谁能解释下之前 为何要引用如此大的一个css 先注释掉吧 有问题再说 */
  /*@import "~@/views/space/personage/index.less";*/
</style>
<script>
import ProjectTable from '_c/common/ProjectTable/Index.vue'
import { getCookie } from '@/assets/utils/CommonUtil'
import spaceService from 'service/space'
import LoadingGif from '_c/loading-gif/index.vue'
// import Bus from '@/assets/utils/bus'

export default {
  name: 'SpaceFilesList',
  components: {
    LoadingGif,
    ProjectTable
  },
  data () {
    return {
      dataList: [],
      UploadCloudFilesShow: true,
      user: {},
      HasUsedWorkspace: false,
      loading: true
    }
  },
  computed: {},
  methods: {
    showGuide () {
      // 员工资料库是否使用过企业空间
      spaceService.getHasUsedWorkspace().then((result) => {
        if (result && result.data) {
          this.HasUsedWorkspace = true
        } else {
          this.$router.push({
            path: '/space2/guide'
          })
        }
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {},
  created () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    this.showGuide()
  }
}

</script>
